import { sum } from '../shared/math'

const entryKey = (e) => e.categoria ?? e.productHierarchyNodeId ?? '__all__';

const groupByKey = (entries) => {
  const map = new Map();
  for (const e of entries) {
    const k = entryKey(e);
    if (!map.has(k)) map.set(k, []);
    map.get(k).push(e);
  }
  return map;
};

const weightedUnitCost = (entries) => {
  let weightedSum = 0, weightTotal = 0;
  for (const e of entries) {
    if (e.unitCost != null && e.unitsSold != null) {
      weightedSum += e.unitCost * e.unitsSold;
      weightTotal += e.unitsSold;
    }
  }
  return weightTotal > 0 ? weightedSum / weightTotal : null;
};

export const calculateCmvByCategory = ({ salesData, estoquePecasData, estoqueReaisData, monthKeys }) => {
  return monthKeys.map(key => {
    const [year, month] = key.split('-').map(Number);
    const inMonth = (d) => d.year === year && d.month === month;

    const salesEntries = salesData.filter(inMonth);

    const pecasByKey = groupByKey(estoquePecasData.filter(inMonth));
    const reaisByKey = groupByKey(estoqueReaisData.filter(inMonth));

    let cmvTotal = 0, unitsTotal = 0, hasData = false;

    for (const [k, entries] of groupByKey(salesEntries)) {
      const units = sum('unitsSold', entries);
      if (units == null) continue;

      const inboundUnits = sum('inboundInventoryUnits', pecasByKey.get(k) ?? []);
      const inboundValue = sum('realPortfolioValue', reaisByKey.get(k) ?? []);
      const carteiraCost = (inboundUnits != null && inboundValue != null && inboundUnits !== 0)
        ? inboundValue / inboundUnits
        : null;

      const cost = carteiraCost ?? weightedUnitCost(entries);
      if (cost == null) continue;

      cmvTotal += units * cost;
      unitsTotal += units;
      hasData = true;
    }

    return {
      _cmvTotal: hasData ? cmvTotal : null,
      _cmvUnitCost: hasData && unitsTotal > 0 ? cmvTotal / unitsTotal : null,
    };
  });
};